import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import LoginContainer from '../features/auth/LoginContainer';
import LoginLayout from '../layouts/auth/login-layout';
import ProtectedRoute from './ProtectedRoutes';
import { AuthProvider } from '../context/AuthContext';
import ResetPassword from '../features/auth/components/ResetPassword';
import SetupLayout from '../layouts/setup/setup-layout';
import UsersContainer from '../features/setup/user-management/UsersContainer';
import AddEditUserComponent from '../features/setup/user-management/component/AddEditUser';
import IndicatorMappingContainer from '../features/setup/indicator-mapping/IndicatorMappingContainer';
import ReportsMappingContainer from '../features/setup/reports-mapping/ReportsMappingContainer';
import HomeContainer from '../features/home/HomeContainer';
import ChangePassword from '../features/auth/components/ChangePassword';
import Indicators from '../features/data-collection/indicators/Indicators';
import ReportIndicators from '../features/reports/indicators/ReportIndicators';
import AddUpdateIndicatorMapping from '../features/setup/indicator-mapping/component/IndicatorMapping';
import AddUpdateReportsMapping from '../features/setup/reports-mapping/component/AddUpdateReportsMapping';

const AppRoutes: React.FC = () => {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route element={<LoginLayout />}>
                        <Route path="/" element={<Navigate to="/login" replace />} />
                        <Route path="/login" element={<LoginContainer />} />
                        <Route path="/reset-password/:tokenForgotPassword" element={<ResetPassword />} />
                    </Route>
                    <Route element={<ProtectedRoute />}>
                        <Route element={<SetupLayout />}>
                            <Route path="/home" element={<HomeContainer />} />
                            <Route path="/setup/user-management" element={<UsersContainer />} />
                            <Route path="setup/user-management/add" element={<AddEditUserComponent isEdit={false} />} />
                            <Route path="/setup/user-management/edit/:userId" element={<AddEditUserComponent isEdit={true} />} />
                            <Route path="/setup/indicators-mapping" element={<IndicatorMappingContainer />} />
                            <Route path="/setup/indicators-mapping/add" element={<AddUpdateIndicatorMapping isEdit={false} />} />
                            <Route path="/setup/indicators-mapping/edit/:ministryId" element={<AddUpdateIndicatorMapping isEdit={true} />} />
                            <Route path="/setup/reports-mapping" element={<ReportsMappingContainer />} />
                            <Route path="/setup/reports-mapping/add" element={<AddUpdateReportsMapping isEdit={false} />} />
                            <Route path="/setup/reports-mapping/edit/:ministryId" element={<AddUpdateReportsMapping isEdit={true} />} />
                            <Route path="/change-password" element={<ChangePassword />} />
                            <Route path="/indicator/:indicatorId" element={<Indicators />} />
                            <Route path="/reports/:indicatorId" element={<ReportIndicators />} />
                        </Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
};

export default AppRoutes;